export default __webpack_public_path__ + "assets/images/12eb392a4360a42c71593360076a2d6b.png";